<template>
  <div class="home">
    
    <!--<theme-vue-material/>
    <theme-cool/>-->
    <component v-bind:is="layout"></component>
  </div>
</template>

<script>
// @ is an alias to /src
//import ThemeCool from '@/components/ThemeCool';
//import ThemeVueMaterial from '@/components/ThemeVueMaterial';

export default {
  name: "home",

  computed: {
    layout () {
      const themename = this.$store.state.currentTheme
      return () => import('@/components/'+themename+'/'+themename)
    }
  },
  components: {
    //'theme-cool': ThemeCool,
    //'theme-vue-material': ThemeVueMaterial
    // define as many layouts you want for the application
  }
/*
  components: {
    ThemeCool,
    ThemeVueMaterial
  }*/
};
</script>
